class MainProduct {
	constructor() {
		this._init();
	}

	_init() {

		const _theme = window.theme;
		let $class = this;

		let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
		let galleryThumbsLink = $('.product-photos .load-all-thumbs').length;

		//Check if desktop screen and meta click expand all thumbs button (default theme ui element)
		if (!isMobile && galleryThumbsLink) {
			setTimeout(function() {
				$('.load-all-thumbs').click();
			}, 500);
		}

		var upsell_products = $("#upsell-prod-group").detach();
		$(".accordion-container").append(upsell_products);

	}
}

export default MainProduct;
